import { commentItems } from '@/mocks/homeData';

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            读者心声
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            来自真实读者的评价与反馈，你的阅读体验是我们持续进步的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {commentItems.map((item) => (
            <div
              key={item.name}
              className="p-5 md:p-6 rounded-2xl bg-background-100 border border-background-200/60 flex flex-col gap-4"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-heading text-primary-600">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-heading text-foreground-900">{item.name}</h3>
                  <p className="text-xs text-foreground-500">{item.date}</p>
                </div>
              </div>

              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i} className="text-sm">
                    <i
                      className={`${
                        i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                      }`}
                    ></i>
                  </span>
                ))}
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed flex-1">{item.content}</p>

              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-thumb-up-line"></i>
                </div>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}